// extracted by mini-css-extract-plugin
export default {"imageBoxContainer":"BlockFullBleedImage_imageBoxContainer__gj0oz"};